// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5861c462","455":"48149b12","977":"67b9b7aa"}[chunkId] + ".chunk.js";
};